module.exports = __webpack_public_path__ + "1671c08f.png";